export default __webpack_public_path__ + "static/media/no-results.468baca9.svg";